export default class Tag {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get id() {
        return this.dto.id;
    }
    set id(id) {
        this.dto.id = id;
    }
    get team() {
        if (!this.dto.team) {
            return null;
        }
        return this.dto.team.replace('/teams/', '');
    }
    set team(team) {
        if (team) {
            this.dto.team = team;
        }
        else {
            this.dto.team = null;
        }
    }
    get project() {
        if (!this.dto.project) {
            return null;
        }
        return this.dto.project.replace('/projects/', '');
    }
    set project(project) {
        if (project) {
            this.dto.project = project;
        }
        else {
            this.dto.project = null;
        }
    }
    get title() {
        return this.dto.title;
    }
    set title(title) {
        this.dto.title = title;
    }
}
//# sourceMappingURL=tag.js.map